<div class="dual-list-box" *ngIf="config.type=='sample1'">

	<div class="listbox" [ngStyle]="{ 'order' :  direction() ? 1 : 2, 'margin-left' : direction() ? 0 : '10px' }">
		<button type="button" name="addBtn" class="btn btn-primary btn-block"
		        (click)="moveItem(available, confirmed)" [ngClass]="direction() ? 'point-right' : 'point-left'"
		        [disabled]="available.pick.length === 0">{{config.format.add}}</button>

		<form *ngIf="filter" class="filter">
			<input
					class="form-control"
					name="filterSource"
					[(ngModel)]="available.picker"
					(ngModelChange)="onFilter(available)">
		</form>

		<div class="record-picker">
			<ul [ngStyle]="{'max-height': height, 'min-height': height}" [ngClass]="{over:available.dragOver}"
			    (drop)="drop($event, confirmed)" (dragover)="dragOver($event, available)" (dragleave)="dragLeave()">
				<li *ngFor="let item of available.sift; let idx=index;"
				    (click)="disabled ? null : selectItem(available.pick, item); shiftClick($event, idx, available, item)"
				    [ngClass]="{selected: isItemSelected(available.pick, item), disabled: disabled}"
				    [draggable]="!disabled && config.format.draggable"
				    (dragstart)="dragStart($event, item, available)"
				    (dragend)="dragEnd(available)"
				><label>{{item._name}}</label></li>
			</ul>
		</div>

		<div class="button-bar">
			<button type="button" class="btn btn-primary pull-left" (click)="selectAll(available)"
			        [disabled]="disabled || isAllSelected(available)">{{config.format.translate.all}}</button>
			<button type="button" class="btn btn-default pull-right" (click)="selectNone(available)"
			        [disabled]="!isAnySelected(available)">{{config.format.translate.none}}</button>
		</div>
	</div>

	<div class="listbox" [ngStyle]="{ 'order' : direction() ? 2 : 1, 'margin-left' : direction() ? '10px' : 0 }">
		<button type="button" name="removeBtn" class="btn btn-primary btn-block"
		        (click)="moveItem(confirmed, available)" [ngClass]="direction() ? 'point-left' : 'point-right'"
		        [disabled]="confirmed.pick.length === 0">{{config.format.translate.buttons.remove}}</button>

		<form *ngIf="filter" class="filter">
			<input
				class="form-control"
				name="filterDestination"
				[(ngModel)]="confirmed.picker"
				(ngModelChange)="onFilter(confirmed)">
		</form>

		<div class="record-picker form-control">
			<ul [ngStyle]="{'max-height': height, 'min-height': height}" [ngClass]="{over:confirmed.dragOver}"
			    (drop)="drop($event, available)" (dragover)="dragOver($event, confirmed)" (dragleave)="dragLeave()">
				<li #itmConf *ngFor="let item of confirmed.sift; let idx=index;"
				    (click)="disabled ? null : selectItem(confirmed.pick, item); shiftClick($event, idx, confirmed, item)"
				    [ngClass]="{selected: isItemSelected(confirmed.pick, item), disabled: disabled}"
				    [draggable]="!disabled && config.format.draggable"
				    (dragstart)="dragStart($event, item, confirmed)"
				    (dragend)="dragEnd(confirmed)"
				><label>{{item._name}}</label></li>
			</ul>
		</div>

		<div class="button-bar">
			<button type="button" class="btn btn-primary pull-left" (click)="selectAll(confirmed)"
			        [disabled]="disabled || isAllSelected(confirmed)">{{config.format.translate.all}}</button>
			<button type="button" class="btn btn-default pull-right" (click)="selectNone(confirmed)"
			        [disabled]="!isAnySelected(confirmed)">{{config.format.translate.none}}</button>
		</div>
	</div>

</div>

<div class="dual-list-box" *ngIf="config.type=='sample2'">

	<div class="listbox" [ngStyle]="{ 'order' :  direction() ? 1 : 3 }">
		<form *ngIf="config.filter" class="filter">
			<input
				class="form-control"
				name="filterSource"
				placeholder="{{ config.format.translate.search.available | translate }}"
				[(ngModel)]="available.picker"
				(ngModelChange)="onFilter(available)">
		</form>

		<div class="record-picker">
			<ul [ngStyle]="{'max-height': height, 'min-height': height}" [ngClass]="{over:available.dragOver}"
			    (drop)="drop($event, confirmed)" (dragover)="dragOver($event, available)" (dragleave)="dragLeave()">
				<li *ngFor="let item of available.sift; let idx=index;"
				    (click)="disabled ? null : selectItem(available.pick, item); shiftClick($event, idx, available, item)"
				    [ngClass]="{selected: isItemSelected(available.pick, item), disabled: disabled}"
				    [draggable]="!disabled && config.format.draggable"
				    (dragstart)="dragStart($event, item, available)"
				    (dragend)="dragEnd(available)"
				><label>{{item._name}}</label></li>
			</ul>
		</div>
	</div>


	<div class="col-md-1 col-lg-1 text-center button-bar" [ngStyle]="{'order': 2}">
		<button
			type="button"
			class="btn tig-btn btn-default col-md-12 col-md-offset-1"
			title="{{ config.format.translate.buttons.assign_all | translate }}"
			(click)="selectAll(available);moveItem(available, confirmed);"
			[disabled]="disabled || isAllSelected(available)">
			<span class="glyphicon glyphicon-list"></span>
			<span class="glyphicon glyphicon-chevron-right"></span>
		</button>
		<button
			type="button"
			class="btn tig-btn btn-default col-md-12 col-md-offset-1 vertical-spacing-5"
			title="{{ config.format.translate.buttons.assign | translate }}"
			(click)="moveItem(available, confirmed);"
			[disabled]="!isAnySelected(available)">
			<span class="glyphicon glyphicon-chevron-right"></span>
		</button>

		<button
			type="button"
			class="btn tig-btn btn-default col-md-12 col-md-offset-1 vertical-spacing-5"
			title="{{ config.format.translate.buttons.remove | translate }}"
			(click)="moveItem(confirmed, available);"
			[disabled]="!isAnySelected(confirmed)">
			<span class="glyphicon glyphicon-chevron-left"></span>
		</button>
		<button
			type="button"
			class="btn tig-btn btn-default col-md-12 col-md-offset-1 bottom10"
			title="{{ config.format.translate.buttons.remove_all | translate }}"
			(click)="selectAll(confirmed);moveItem(confirmed, available);"
			[disabled]="disabled || isAllSelected(confirmed)">
			<span class="glyphicon glyphicon-chevron-left"></span>
			<span class="glyphicon glyphicon-list"></span>
		</button>
	</div>


	<div class="listbox" [ngStyle]="{ 'order' : direction() ? 3 : 1 }">
		<form *ngIf="config.filter" class="filter">
			<input
				class="form-control"
				name="filterDestination"
				placeholder="{{ config.format.translate.search.confirmed | translate }}"
				[(ngModel)]="confirmed.picker"
				(ngModelChange)="onFilter(confirmed)">
		</form>

		<div class="record-picker form-control">
			<ul [ngStyle]="{'max-height': height, 'min-height': height}" [ngClass]="{over:confirmed.dragOver}"
			    (drop)="drop($event, available)" (dragover)="dragOver($event, confirmed)" (dragleave)="dragLeave()">
				<li #itmConf *ngFor="let item of confirmed.sift; let idx=index;"
				    (click)="disabled ? null : selectItem(confirmed.pick, item); shiftClick($event, idx, confirmed, item)"
				    [ngClass]="{selected: isItemSelected(confirmed.pick, item), disabled: disabled}"
				    [draggable]="!disabled && config.format.draggable"
				    (dragstart)="dragStart($event, item, confirmed)"
				    (dragend)="dragEnd(confirmed)"
				    [attr.data-id]="item._id"
				>
					<label>
						<input
							*ngIf="this.config?.order.length > 0 && !this.config.orderDrag"
							type="text"
							value="{{item._order}}"
							[(ngModel)]="item._order"
							(ngModelChange)="modelChange($event, confirmed, item);"/>
						{{item._name}}
					</label></li>
			</ul>
		</div>
	</div>

</div>